import { Injectable } from '@angular/core';
import { QuestionAttemptEntityQuery } from '@examdojo/question';
import { SolutionService } from '@examdojo/solution';
import { UserQuery } from '@examdojo/user';
import { Observable, of } from 'rxjs';
import { CanvasExportResult } from './hidden-canvas-exporter.component';

@Injectable()
export class ChallengeCanvasExportService {
  constructor(
    private readonly questionAttemptQuery: QuestionAttemptEntityQuery,
    private readonly userQuery: UserQuery,
    private readonly solutionService: SolutionService,
  ) {}

  getFrqAttemptIds(): string[] {
    return this.questionAttemptQuery
      .getAllEntities()
      .filter((attempt) => !this.questionAttemptQuery.isQuestionMultipleChoice(attempt.id))
      .map((attempt) => attempt.id);
  }

  getCurrentAttemptId(): string | undefined {
    return this.questionAttemptQuery.getActiveId() ?? undefined;
  }

  isCurrentAttemptFrq(): boolean {
    const currentId = this.getCurrentAttemptId();
    return currentId ? !this.questionAttemptQuery.isQuestionMultipleChoice(currentId) : false;
  }

  getUserId(): string | null {
    return this.userQuery.getActiveId() ?? null;
  }

  saveAllCanvasExports(exports: CanvasExportResult[]): Observable<void> {
    const userId = this.getUserId();
    if (!userId) {
      return of(undefined);
    }

    const allItems = exports.flatMap((exp) =>
      exp.files.map((file) => ({ attemptId: exp.attemptId, fileOrPhoto: file })),
    );

    if (allItems.length === 0) {
      return of(undefined);
    }

    return this.solutionService.saveSolutionImages(userId, allItems);
  }
}
